module.exports = __webpack_public_path__ + "img/Group-5122.31d2a8c3.svg";